// extracted by mini-css-extract-plugin
export default {"brand_categories_item":"style_brand_categories_item__D0gw2","brands_simple":"style_brands_simple__f4Pa5"};